import { useEffect, useRef, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface VideoBackgroundProps {
  videoSrc?: string;
  title: string;
  isDimmed?: boolean;
  storageKey?: string;
}

export const VideoBackground = ({ videoSrc, title, storageKey = "background-video.mp4" }: VideoBackgroundProps) => {
  const [videoUrl, setVideoUrl] = useState<string | null>(videoSrc || null);
  const videoRef = useRef<HTMLVideoElement>(null);

  // Fetch video from storage if no direct src provided
  useEffect(() => {
    const fetchVideo = async () => {
      if (!videoSrc) {
        const { data } = supabase.storage.from('videos').getPublicUrl(storageKey);
        if (data?.publicUrl) {
          setVideoUrl(data.publicUrl);
        }
      }
    };
    fetchVideo();
  }, [videoSrc, storageKey]);

  useEffect(() => {
    if (videoRef.current) {
      const video = videoRef.current;
      
      video.addEventListener('loadeddata', () => {
        console.log("Video loaded successfully");
      });
      
      video.addEventListener('error', (e) => {
        console.error("Video error:", e, "Video error code:", video.error);
      });
      
      video.play().catch((error) => {
        console.log("Video autoplay failed:", error);
      });
    }
  }, [videoUrl]);

  if (!videoUrl) return null;

  return (
    <div className="fixed inset-0 w-full h-full overflow-hidden -z-10">
      <video
        ref={videoRef}
        className="w-full h-full object-cover"
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        src={videoUrl}
        aria-label={title}
      >
        <track kind="captions" />
      </video>
      <div className="absolute inset-0 bg-background/30 backdrop-blur-sm" />
    </div>
  );
};
